/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "gbeko_the_analyst",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Ilias Olakunle, Shittu-Gbeko Portfolio",
    type: "website",
    url: "http://gbekoilias.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Ilias Shittu-Gbeko",
  logo_name: "MuhammduIlyas",
  nickname: "gbeko_the_analyst",
  subTitle:
    "Masterful data decoder navigating complex realms, unveiling insights",
  resumeLink:
    "https://drive.google.com/file/d/1psSRSr-5kkpT4n4FBXBv9h7LxKGf4D9E/view?usp=sharing",
  portfolio_repository: "https://github.com/gbekoilias",
  githubProfile: "https://github.com/gbekoilias",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/gbekoilias",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/gbekoilias/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
 // {
 //   name: "YouTube",
 //   link: "https://youtube.com/c/DevSense19",
 //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //  backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
 // },
  {
    name: "Gmail",
    link: "mailto:gbekoilias@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "X-Twitter",
    link: "https://twitter.com/Gbekoilias",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
  //{
   // name: "Facebook",
   // link: "https://www.facebook.com/laymanbrother.19/",
   // fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
   // backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
 // },
 // {
   // name: "Instagram",
   // link: "https://www.instagram.com/layman_brother/",
   // fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
   // backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
 // },
];

const skills = {
  data: [
    {
      title: "Data Wrangling and Visualization",
      fileName: "designImg",
      skills: [
        "⚡ Proficient in web scraping, API integration, and cloud data import to gather diverse datasets for analysis. ",
        "⚡ Skilled in meticulous data cleaning and transformation, ensuring accuracy and usability for analysis",
        "⚡  Developed compelling data visualizations and charts, enhancing data storytelling and comprehension",
      ],
      softwareSkills: [
        {
          skillName: "Wolfram Mathematica",
          fontAwesomeClassname: "simple-icons:wolfram",
          style: {
            color: "#DD1100",
          },
        },
        {
          skillName: "Selenium",
          fontAwesomeClassname: "simple-icons:selenium",
          style: {
            color: "#43B02A",
          },
        },
        {
          skillName: "Scrapy",
          fontAwesomeClassname: "simple-icons:scrapy",
          style: {
            color: "#F7931E",
          },
        },
        {
          skillName: "Postman",
          fontAwesomeClassname: "simple-icons:postman",
          style: {
            color: "#FF6C37",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:azuredevops",
          style: {
            color: "#0078D7",
          },
        },
        {
          skillName: "chrome devtools",
          fontAwesomeClassname: "simple-icons:googlechrome",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: {
            color: "#8CAAE6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    {
      title: "Statistical Analysis",
      fileName: "FullStackImg",
      skills: [
        "⚡ Proficient in testing variable impact with statistical significance.",
        "⚡ Skilled at revealing relationships using precise statistical methods.",
        "⚡ Experienced in extracting trends for accurate future predictions.",
      ],
      softwareSkills: [
        {
          skillName: "R",
          fontAwesomeClassname: "simple-icons:r",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "SASS",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "Numpy",
          fontAwesomeClassname: "simple-icons:numpy",
          style: {
            color: "#013243",
          },
        },
        {
          skillName: "Scipy",
          fontAwesomeClassname: "simple-icons:scipy",
          style: {
            color: "#8CAAE6",
          },
        },
        {
          skillName: "SPSS",
          fontAwesomeClassname: "simple-icons:spss",
          style: {
            color: "#8CAAE6",
          },
        },
      ],
    },
    
    {
      title: "Machine Learning",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with Supervised learning Models",
        "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
        "⚡ Deployed models on Heroku and Streamlit, creating user-friendly web applications for seamless data-driven solutions."
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "simple-icons:tensorflow",
          style: {
            backgroundColor: "#F7931E",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
        {
          skillName: "Streamlit",
          fontAwesomeClassname: "simple-icons:streamlit",
          style: {
            backgroundColor: "white",
            color: "#FF4B4B",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            backgroundColor: "white",
            color: "#430098",
          },
        },
      ],
    },
    {
      title: "Business Intelligence and Analytics",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "Tableau",
          fontAwesomeClassname: "simple-icons:tableau",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "PowerBI",
          fontAwesomeClassname: "simple-icons:powerbi",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "Google Data Studio",
          fontAwesomeClassname: "simple-icons:googledrive",
          style: {
            color: "#8CAAE6",
          },
        },
        {
          skillName: "Looker",
          fontAwesomeClassname: "simple-icons:looker",
          style: {
            color: "#8CAAE6",
          },
        },
        {
          skillName: "Google Analytics",
          fontAwesomeClassname: "simple-icons:googleanalytics",
          style: {
            color: "#8CAAE6",
          },
        },
        {
          skillName: "Microsoft Fabric",
          fontAwesomeClassname: "simple-icons:microsoftoffice",
          style: {
            color: "#8CAAE6",
          },
        },
      ],
    },
    {
      title: "Database Management",
      fileName: "serviceWorker",
      skills: [
        "⚡ Proficient in crafting optimized database structures for swift data access while maintaining integrity and security",
        "⚡ Skilled in leveraging SQL's capabilities for precise data extraction and manipulation, enabling informed decision-making",
        "⚡ Experienced in orchestrating ETL processes for seamless data refinement, integration, and analysis, facilitating actionable insights",
      ],
      softwareSkills: [
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "Google BigQuery",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "MsSQL",
          fontAwesomeClassname: "simple-icons:microsoftsqlserver",
          style: {
            color: "#CC2927",
          },
        },
        {
          skillName: "Ms Access",
          fontAwesomeClassname: "simple-icons:microsoftaccess",
          style: {
            color: "#A4373A",
          },
        },
        {
          skillName: "Oracle",
          fontAwesomeClassname: "simple-icons:oracle",
          style: {
            color: "#F80000",
          },
        },
      ],
    },
    {
      title: "Spreadsheet Management",
      fileName: "FullStackImg",
      skills: [
        "⚡ Structuring spreadsheets for enhanced clarity and seamless navigation.",
        "⚡ Executing intricate calculations and in-depth analysis using spreadsheet functions",
        "⚡ Generating visual representations to facilitate efficient data communication",
      ],
      softwareSkills: [
        {
          skillName: "Excel",
          fontAwesomeClassname: "simple-icons:microsoftexcel",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "Google Sheets",
          fontAwesomeClassname: "simple-icons:googlesheets",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "LaTeX",
          fontAwesomeClassname: "simple-icons:latex",
          style: {
            color: "#4479A1",
          },
        },
      ],
    },
    {
      title: "Technical Report Writing",
      fileName: "designImg",
      skills: [
        "⚡ Crafting comprehensive ML papers with novel methodologies and statistical analysis",
        "⚡ Generating detailed analysis reports from complex datasets using statistical tools",
        "⚡ Creating precise scientific documentation and translating technical findings for broader understanding",
        "⚡ Leading STEM projects from conceptualization to execution, contributing to advancements in diverse fields."
      ],
      softwareSkills: [
        {
          skillName: "PowerPoint",
          fontAwesomeClassname: "simple-icons:microsoftpowerpoint",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "Google Slides",
          fontAwesomeClassname: "simple-icons:googleslides",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "Word",
          fontAwesomeClassname: "simple-icons:microsoftword",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "Notion",
          fontAwesomeClassname: "simple-icons:notion",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "Google Docs",
          fontAwesomeClassname: "simple-icons:googledocs",
          style: {
            color: "#4479A1",
          },
        },
        
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/gbekoilias/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/gbekoilias",
    },
    {
      siteName: "Stack Overflow",
      iconifyClassname: "simple-icons:stackoverflow",
      style: {
        color: "#FE7A16",
      },
      profileLink: "https://stackoverflow.com/users/16774366/gbekoilias",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/gbekoilias",
    },
    {
      siteName: "Quora",
      iconifyClassname: "simple-icons:quora",
      style: {
        color: "#B92B27",
      },
      profileLink: "https://www.quora.com/profile/GbekoIlias?ch=18&oid=1152527993&share=80b32df7&srid=uRfAZi&target_type=user",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Federal University of Technology, Minna",
      subtitle: "B.Eng. in Metallurgical and Materials Engineering",
      logo_path: "fut_logo.png",
      alt_name: "Futminna",
      duration: "2017 - 2023",
      descriptions: [
        "⚡ Graduated with first-class honors, recognized as the department's top-performing student, showcasing excellence and innovation in engineering concepts and materials science.",
        "⚡Acquired expertise in material properties, processing, and metallurgical techniques, laying the groundwork for advanced engineering proficiency.",
        "⚡ Contributed to pioneering research initiatives in novel materials and process optimization, potentially influencing industry practices and academic advancements.",
      ],
      website_link: "http://futminna.edu.ng/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Neural Network and Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://coursera.org/share/13912a5f6e1f28e210f82141ef283eee",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Data Science",
      subtitle: "- Alex Aklson",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://coursera.org/share/9e282ec970119707156877de3a1e64b8",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Power Platform Fundamentals",
      subtitle: "- Yusuf Adewale",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1bMhWeFieIRchLMCujgsusdDPNXhCFr_I/view?usp=sharing",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Data Curation for Storytelling",
      subtitle: "- HDSC Fall 23",
      logo_path: "hamoye_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1NPc9dEdylSm7MXx1y99K25a35nUII7R6/view?usp=drive_link",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Introduction to Machine Learning",
      subtitle: "- ML Crash Course",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1R0aRkay-_965izD46TPQaAHIxRCd1jzw/view?usp=drive_link",
      alt_name: "Microsoft",
      color_code: "#0C9D5899",
    },
    {
      title: "Data Visualization with Power BI",
      subtitle: "- gl",
      logo_path: "great-learning-logo.jpg",
      certificate_link:
        "https://drive.google.com/file/d/14MeG5-LzJ0FJPPBiN607pTXT7aQjOPpK/view?usp=drive_link",
      alt_name: "great learning",
      color_code: "#FFBB0099",
    },
    
    {
      title: "Cluster Analysis",
      subtitle: "- ML series",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1sjS9mrILvoIy5kDGQ2lf6uO2-gyd49nv/view?usp=drive_link",
      alt_name: "CM",
      color_code: "#1F70C199",
    },
    {
      title: "Advanced Statistics",
      subtitle: "Stat",
      logo_path: "great-learning-logo.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1-dwCi279Ua6XmFbRdNq0yFB7aNgnVhTH/view?usp=drive_link",
      alt_name: "GLL",
      color_code: "#FFBB0099",
    },
    {
      title: "Data Storytelling",
      subtitle: "- HDSC Spring 2021",
      logo_path: "hamoye_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1vKLUR5Uup7aG6JpeqESMbARhrsOAErxW/view?usp=drive_link",
      alt_name: "Hamoye",
      color_code: "#1F70C199",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description: 
    "I have a diverse background in data analysis and storytelling, gained from pivotal roles in various industries. My experiences range from analyzing global trends to collaborating on diagnostic models for predictive analytics. Working with teams, I've contributed to generating actionable insights for business growth and decision-making. These experiences, coupled with my educational background and certifications in data analysis tools, underscore my commitment to leveraging data effectively. Moreover, my active engagement in volunteering and participation in hackathons reflect my dedication to continuous learning and community-driven initiatives.",
  
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Freelance Data Scientist",
          company: "FUTMinna",
          company_url: "https://www.futminna.edu.ng/",
          logo_path: "fut_logo.png",
          duration: "June 2023- Present",
          location: "Minna, Niger State",
          description:
            "Supporting final year students in their undergraduate thesis by providing solutions in Data Analysis, Statistical Analysis, and Machine Learning projects. Concurrently, developing Machine Learning web applications to enable predictive analysis and facilitate model deployment for informed decision-making.",
          color: "#0879bf",
        },
        {
          title: "Junior Data Analyst",
          company: "Borderless Incubator",
          company_url: "https://abocoders.org.ng/about-us/our-solution/",
          logo_path: "bordeless_logo.png",
          duration: "April 2022 - Jan 2023",
          location: "Minna, Niger State",
          description:
            "At Borderless Incubator, I oversaw daily data collection from logistics platforms, ensuring robust data quality and quantity. Orchestrated telecom product surveys and market research, extracting valuable customer insights to uncover market trends and preferences in our AI-driven solutions.",
          color: "#9b1578",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Data Storytelling Intern",
          company: "Hamoye AI Labs.",
          company_url: "https://www.hamoye.com/",
          logo_path: "hamoye_new_logo.png",
          duration: "Sept 2023 - Dec 2023",
          location: "Lagos, Nigeria",
          description:
            " As a query analyst, I analyzed temperature data from the GHCnD network spanning 1980 to 2022 in West Africa. This involved identifying climate change patterns across 15 countries and developing area-based models for forecasting extreme temperatures",
          color: "#ee3c26",
        },
        {
          title: "Data Analyst Intern",
          company: "Meriskills Technologies",
          company_url: "https://sites.google.com/view/meriskill/home",
          logo_path: "Meriskills_logo.jpg",
          duration: "Aug 2023 - Oct 2023",
          location: "Pima, India",
          description:
            "• Worked with a team to produce a weekly sales dashboard that highlighted significant revenue growth and profit margins for Meri Skill subsidiaries\n• Collaborated with a team of machine learning engineers in the development of a diagnostic model (79% accuracy) for predicting diabetes cases in Pima Heritage women, India.",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Query Analyst",
          company: "Eonflux",
          company_url: "https://github.com/Gbekoilias/Eonflux_Capstone_Project_HDSC_FALL_23",
          logo_path: "Eonflux_logo.png",
          duration: "Nov 2023 - Dec 2023",
          location: "Lagos, Nigeria",
          description:
            "Led the documentation of a research project on temperature predictions across 15 West African countries' weather stations. Provided a comprehensive analysis of average temperatures recorded over the last 42 years (1980-2022). Reviewed and approved merge changes and Pull Requests for the dedicated GitHub repository of the project.",
          color: "#4285F4",
        },
        {
          title: "Project Lead",
          company: "InsightIQ",
          company_url: "https://github.com/Gbekoilias/Insights_IQ-Premiere-Project-HDSC-23",
          logo_path: "insight_iq_logo.jpeg",
          duration: "Oct 2023 - Nov 2023",
          location: "Lagos, Nigeria",
          description:
            "Coordinated and led the team in an end-to-end data science project focused on Global Energy Transition Analysis, culminating in the development of a 92% accurate Energy Forecasting model predicting energy goals for 20 countries from 2020 to 2030.",
          color: "#196acf",
        },
        {
          title: "Cyber Smart Volunteer",
          company: "ATC Africa",
          company_url: "https://atcafrica.com/",
          logo_path: "amazingtech_community_logo.jpg",
          duration: "Oct 2023",
          location: "Minna, Niger State",
          description:
            "Joined forces with other amazing volunteers in promoting internet safety and digital literacy in Minna City. Its importance lies in creating a safer online environment while empowering individuals with the knowledge and skills to navigate the digital world securely.",
          color: "#9b1578",
        },
        {
          title: "Python/ML Educator",
          company: "DSN FUTMinna",
          company_url:
            "https://www.datasciencenigeria.org/",
          logo_path: "dsnai_logo.jpg",
          duration: "July 2021 - March 2022",
          location: "Gidan  Kwano, Minna",
          description:
            " Educated beginners in ML/AI on essential Mathematical and Statistical concepts vital in Data Science, providing foundational knowledge. Taught fundamental Machine Learning Algorithm principles to aspiring learners, particularly youngsters, fostering a deeper understanding.",
          color: "#fc1f20",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "I have spearheaded diverse data-driven projects encompassing sales analysis, HR analytics, market reviews, and credit card segmentation. These projects showcase my prowess in data manipulation, analysis, and extraction of actionable insights using a range of tools and methodologies. Leveraging varied tech stacks and skills like data mining, visualization, and machine learning, these experiences underline my ability to solve complex problems and derive meaningful conclusions from data.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked and collaborated to publish a research paper on Artificial Intelligence for Climatic Change",
  avatar_image_path: "projects_image.svg",
};
const publications = {
  data: [
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
      name: "AI for Climatic Change",
      createdAt: "2023-12-16T16:26:54Z",
      description: "A Research Paper on Climatic Change in  West Africa ",
      url:
        "https://docs.google.com/document/d/1dTGLqTrNrRfgUY7lBrT4P8LN9ZTFcLOSDDJZaL4ZfIc/edit?usp=drive_link",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
      name: "Energy Research Paper",
      createdAt: "2020-12-06T16:26:54Z",
      description: "A Report on Global Energy Transition Analysis ",
      url:
        "https://docs.google.com/document/d/1JwOAixlM24URWR6VMw3mqe_AGcEGIErb/edit?usp=sharing&ouid=113420828555007345949&rtpof=true&sd=true",
    },
    
    
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "gta3.jpeg",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with data analysis, statistical analysis, data science tasks and machine leanring projects.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I enjoy crafting Machine Learning and Explorative Data Analysis reports and blog posts that aid newcomers while simultaneously deepening my understanding of concepts I'm exploring. These materials serve to empower individuals by imparting foundational knowledge and strengthening my grasp on various concepts within the field.",
    link: "https://medium.com/@gbekoilias",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "No 16, Oke Apon, Koso Layout, Iseyin",
    locality: "Oke Ogun",
    country: "NG",
    region: "Oyo State",
    postalCode: "202101",
    streetAddress: "Koso",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/krNRDjDdhdNqrGCX8",
  },
  phoneSection: {
    title: "Mobile Phone Number",
    subtitle: "+(234) 810 7097 907",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
